import React from 'react';

const Pagination = ({ currentPage, totalPages, onPageChange, limit, onLimitChange, totalItems }) => {
    if (totalItems === 0) return null;

    return (
        <div className="px-8 py-4 bg-slate-50 dark:bg-slate-800/30 border-t border-slate-200 dark:border-slate-800 flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex flex-col">
                <p className="text-[10px] font-black uppercase tracking-widest text-slate-400">Affichage</p>
                <p className="text-sm font-bold text-slate-600 dark:text-slate-400">
                    {limit >= 1000000 ? (
                        `Totalité des ${totalItems} articles`
                    ) : (
                        `Articles ${limit * (currentPage - 1) + 1} à ${Math.min(limit * currentPage, totalItems)} sur ${totalItems}`
                    )}
                </p>
            </div>

            <div className="flex items-center gap-2 bg-white dark:bg-slate-900 p-1.5 rounded-2xl border border-slate-200 dark:border-slate-700 shadow-sm mx-auto">
                <button
                    onClick={() => onPageChange(Math.max(1, currentPage - 1))}
                    disabled={currentPage === 1 || limit >= 1000000}
                    className="px-4 py-2 text-[10px] font-black uppercase rounded-xl hover:bg-slate-50 dark:hover:bg-slate-800 disabled:opacity-30 transition-all flex items-center gap-2 text-slate-400"
                >
                    <span className="material-symbols-outlined text-[18px]">chevron_left</span> Précédent
                </button>
                <div className="h-6 w-px bg-slate-100 dark:bg-slate-800"></div>
                <div className="px-4 text-[11px] font-black text-primary uppercase tracking-widest">
                    {limit >= 1000000 ? 'Vue Globale' : `Page ${currentPage} / ${totalPages}`}
                </div>
                <div className="h-6 w-px bg-slate-100 dark:bg-slate-800"></div>
                <button
                    onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
                    disabled={currentPage === totalPages || limit >= 1000000}
                    className="px-4 py-2 text-[10px] font-black uppercase rounded-xl hover:bg-slate-50 dark:hover:bg-slate-800 disabled:opacity-30 transition-all flex items-center gap-2 text-slate-600 dark:text-slate-300"
                >
                    Suivant <span className="material-symbols-outlined text-[18px]">chevron_right</span>
                </button>
            </div>

            <div className="flex items-center gap-3">
                <span className="text-[10px] font-black uppercase tracking-widest text-slate-400">Par page :</span>
                <select
                    value={limit}
                    onChange={(e) => onLimitChange(parseInt(e.target.value))}
                    className="h-10 px-4 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-xl text-xs font-bold focus:ring-2 focus:ring-primary/20 outline-none cursor-pointer"
                >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="1000000">Tout</option>
                </select>
            </div>
        </div>
    );
};

export default Pagination;
